import React from 'react';

import Seal from 'assets/livenicons/quarantee.svg';

import styles from './styles.module.scss';

export const MoneyGuarantee = () => {
  return (
    <div className={styles.checkoutMoneyback}>
      <div className={styles.checkoutMoneybackBox}>
        <h5>30-Day Money-Back Guarantee</h5>
        <p>
          Our plan is backed by a money-back guarantee. We believe that our plan
          will work for you, that we guarantee a full refund within 30 days
          after purchase if you don't see visible results in your ability to
          reduce negative effects despite following your plan as directed. Find
          more about applicable limitations in our money-back policy
        </p>
      </div>
      <div className={styles.seal}>
        <img src={Seal} alt="" />
      </div>
    </div>
  );
};
